import loginSuccessImage from 'Assets/images/login-success.svg';
import bhiveLogo from 'Assets/images/logo.svg';
import { AUTH0_ELECTRON_REDIRECT_URI } from 'Constants/env';
import { AuthenticationLayout } from 'Containers/AuthenticationLayout';
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { pushToGTMDataLayer } from 'Utils/analytics';
import { Button } from '~/lib/ui/button';

export const AuthenticationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const auth0QueryParamsRef = useRef<string | null>(null);

  /**
   * Handle manual click on "Click here" button
   */
  const handleManualRedirect = () => {
    pushToGTMDataLayer('login_open_desktop', {
      action: 'click',
      label: 'manual_click_here',
    });
  };

  /**
   * Redirect to the desktop app.
   */
  const redirectToElectron = () => {
    if (!window?.location || !auth0QueryParamsRef.current) {
      return;
    }

    pushToGTMDataLayer('login_open_desktop', {
      action: 'redirect',
      label: 'automatic_redirect',
    });

    window.location.replace(
      `${AUTH0_ELECTRON_REDIRECT_URI}${auth0QueryParamsRef.current}`
    );
  };

  /**
   * Save the incoming query parameters from Auth0 as ref and redirect to the desktop app.
   */
  useEffect(() => {
    auth0QueryParamsRef.current = location.search;

    pushToGTMDataLayer('login_successfull', {
      action: 'success',
      label: 'authentication_complete',
    });

    void navigate(location.pathname, { replace: true });
    redirectToElectron();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthenticationLayout rightImage={loginSuccessImage}>
      <img src={bhiveLogo} alt="BHive Logo" className="w-[250px] mb-11" />
      <h1 className="text-[30px] leading-[41px] mb-4">Opening Communicator…</h1>
      <p className="text-[18px] leading-[25px] mb-4">
        We’re opening the desktop app for you.
      </p>
      <p className="text-left leading-[19px] text-[14px]">
        If the app didn’t open, try again.{' '}
        <Button variant="link" className="px-0 h-auto !underline decoration-primary text-[14px] leading-[19px]">
          <a
            href={`${AUTH0_ELECTRON_REDIRECT_URI}${auth0QueryParamsRef.current}`}
            target="_self"
            rel="noopener noreferrer"
            onClick={handleManualRedirect}
            className='text-primary!'
          >
            Open app
          </a>
        </Button>
      </p>
    </AuthenticationLayout>
  );
};
